import { ListWorkspacesRepsonseClass, WorkspaceClass, WorkspacesApi } from '@emilgroup/auth-sdk';
import { AuthMode } from 'Services/api/auth/base';

const listWithCookie = async ( apiUrl: string ): Promise<WorkspaceClass[]> => {
  const response = await fetch( new URL( 'authservice/v1/workspaces', apiUrl ).toString(), { credentials: 'include' } );
  if ( !response.ok ) {
    throw new Error( `Listing workspaces with the access cookie failed: ${ response.status }` );
  }
  const body: ListWorkspacesRepsonseClass = await response.json();

  return body?.workspaces || [];
};

/** In dual mode the list is read with the HttpOnly cookie; the SDK and its header stay the fallback. */
export const listWorkspaces = async (
  authMode: AuthMode | undefined,
  loggedInAccounts: number,
  workspaceService: WorkspacesApi,
  apiUrl: string,
  onCookieError?: ( error: unknown ) => void,
): Promise<WorkspaceClass[]> => {
  // The browser holds one access cookie; with several accounts it may belong to another one.
  if ( authMode === 'dual' && loggedInAccounts === 1 ) {
    try {
      return await listWithCookie( apiUrl );
    } catch ( error ) {
      onCookieError?.( error );
    }
  }
  const response = await workspaceService.listWorkspaces();

  return ( response?.data as ListWorkspacesRepsonseClass )?.workspaces || [];
};
